import {languagePackage} from "./language";

const MedicalPageType = {
	findDoctor: 'findDoctor',
	schedule: 'schedule',
	medication: 'medication',
	message: 'message',
	labReport: 'labReport',
	visitHistory: 'visitHistory',
	vaccination: 'vaccination',
	myMonitor: 'myMonitor',
	inviteFriend: 'inviteFriend',
	nearbyPharmacy: 'nearbyPharmacy',
	telehealth: 'teleHealth',
	insurance: 'insurance',
	howTo: 'howTo',
	explore: 'explore',
	blank: 'blank',
	covid: 'covid',
	files: 'files'
}

const Language = {
	english: 'English',
	chinese: 'Chinese',
	spanish: 'Spanish'
}

const ScanType = {
	register: 0,
	getDoctorInfo: 1,
}

const TimeFormat = {
	YYYYMMDD: 'YYYY-MM-DD',
	MMDDYYYY: 'MM/DD/YYYY',
	YYYYMMDDHHmmss: 'YYYY-MM-DD HH:mm:ss',
	YYYYMMDDTHHmmss: 'YYYY-MM-DDTHH:mm:ss',
	MMDDYYYYHHmmss: 'MM/DD/YYYY HH:mm:ss',
	HHmmMMDDYYYY: 'HH:mm MM/DD/YYYY',
	MMDDYYYYHHmm: 'MM/DD/YYYY HH:mm',
	HHmmMMDD: 'HH:mm MM/DD',
	HHmm: 'HH:mm',
	HHmmss: 'HH:mm:ss',
}

const PLATFORM = {
	isAndroid: /Android/.test(window.navigator.userAgent),
	isIOS: ['iPhone', 'iPad', 'iPod'].indexOf(window.navigator.platform) !== -1,
	isIphoneX: (['iPhone', 'iPad', 'iPod'].indexOf(window.navigator.platform) !== -1) && (window.screen.height >= 812)
}

const getWeekList = () => {
	return [
		languagePackage().Sunday,
		languagePackage().Monday,
		languagePackage().Tuesday,
		languagePackage().Wednesday,
		languagePackage().Thursday,
		languagePackage().Friday,
		languagePackage().Saturday
	]
}

const getMonthList = () => {
	return [
		languagePackage().January,
		languagePackage().February,
		languagePackage().March,
		languagePackage().April,
		languagePackage().May,
		languagePackage().June,
		languagePackage().July,
		languagePackage().August,
		languagePackage().September,
		languagePackage().October,
		languagePackage().November,
		languagePackage().December
	]
}

export const MontShortNameList = [
	languagePackage().Jan,
	languagePackage().Feb,
	languagePackage().Mar,
	languagePackage().Apr,
	languagePackage().Mays,
	languagePackage().Jun,
	languagePackage().Jul,
	languagePackage().Aug,
	languagePackage().Sep,
	languagePackage().Oct,
	languagePackage().Nov,
	languagePackage().Dec
]

export const WeekShortNameList = [
	languagePackage().Sun,
	languagePackage().Mon,
	languagePackage().Tue,
	languagePackage().Wed,
	languagePackage().Thu,
	languagePackage().Fri,
	languagePackage().Sat
]

const VisitType = {
	inClinic: 0,
	virtual: 1
}

const SchemeUrlCategory = {
	accessCode: 'accesscode',
	register: 'register',
	doctorInfo: 'doctorinfo',
	openSchedule: 'openSchedule'
}

const OSType = {
	macOS: 0,
	ios: 1,
	window: 2,
	android: 3,
	linux: 4
}

const getOS = () => {
	let userAgent = window.navigator.userAgent,
		platform = window.navigator.platform,
		macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
		windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
		iosPlatforms = ['iPhone', 'iPad', 'iPod'],
		os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = OSType.macOS;
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = OSType.ios;
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = OSType.window;
	} else if (/Android/.test(userAgent)) {
		os = OSType.android;
	} else if (!os && /Linux/.test(platform)) {
		os = OSType.linux;
	}

	return os;
}

const DigitalHealthEmail = 'digitalhealth@mdland.com'

export {
	MedicalPageType,
	Language,
	TimeFormat,
	ScanType,
	VisitType,
	getWeekList,
	getMonthList,
	PLATFORM,
	SchemeUrlCategory,
	getOS,
	OSType,
	DigitalHealthEmail
}
